export default class TimeclockClockingRequest {
  public employeeId: number;

  public clockingAction: string;

  public worklogType: string | null;
}
